import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useParams } from "react-router";
import { getUsers } from "../../api/getUsers";
import { User } from "../../models/user.model";
import { responseHero } from "../../utils/axiosInterceptor";
import { getNewsletterSubscriptionList } from "../../api/getNewsletterSubscriptionList";
import { useLocation } from "react-router";

export default function NewsLetterSubscriptionHandler() {
    const { id } = useParams();

    const location = useLocation();
    const listName = location.state?.name;

    const [users, setUsers] = useState<User[]>([]);
    const [selectedUsers, setSelectedUsers] = useState<Set<number>>(new Set());

    const [loader, setLoader] = React.useState<boolean>(false);

    useEffect(() => {
        if (!id) return;

        const fetchData = async () => {
            setLoader(true)
            try {
                const subscriptions = await getNewsletterSubscriptionList(parseInt(id, 10));
                const allUsers = await getUsers();
                const selectedIds = new Set(subscriptions.map(sub => sub.user_id));

                setUsers(allUsers);
                setSelectedUsers(selectedIds);

                
            } catch (error) {
                console.error("Hiba az adatok betöltésekor:", error);
            } finally {
                setLoader(false)
            }
        };

        fetchData();
    }, [id]);

    const toggleCheckbox = (userId: number) => {
        setSelectedUsers(prev => {
            const updated = new Set(prev);
            updated.has(userId) ? updated.delete(userId) : updated.add(userId);
            return updated;
        });
    };

    const handleSave = async () => {
        const selected = users.filter(user => selectedUsers.has(user.user_id)).map((user) => user.user_id);
        await responseHero.post(`${process.env.REACT_APP_API_URL}/newslettersubscription/${id}`, {
            userIds: selected
        }).then((response) => {
            toast.success("Sikeresen mentetted a levelezőlistát!")
        }).catch(error => {
            console.error(error.response.data);
            toast.error("Hiba a lista mentése közben!")
        });
    };

    return (
        <div className="m-5 p-3">
            <div className="overflow-x-auto w-full max-w-4xl mx-auto">
            {loader ? <p className="text-center text-lg animation-pulse">Levelezőlista résztvevőinek betöltése...</p>
            :
            <>
                <h1 className="text-xl font-bold mb-4 text-center">
                    {listName ? `Levelezőlista: ${listName}` : "Nem található"}
                </h1>


                <table className="min-w-full border border-gray-200 text-sm">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="text-left px-4 py-2 border-b font-medium">Sorszám</th>
                            <th className="text-left px-4 py-2 border-b font-medium">Név</th>
                            <th className="text-left px-4 py-2 border-b font-medium">Email cím</th>
                            <th className="text-left px-4 py-2 border-b font-medium">Kiválasztva</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user, index) => (
                            <tr key={user.user_id} className="hover:bg-gray-50">
                                <td className="px-4 py-2 border-b">{index + 1}</td>
                                <td className="px-4 py-2 border-b">{user.name}</td>
                                <td className="px-4 py-2 border-b">{user.email}</td>
                                <td className="px-4 py-2 border-b">
                                    <input
                                        type="checkbox"
                                        className="w-6 h-6"
                                        checked={selectedUsers.has(user.user_id)}
                                        onChange={() => toggleCheckbox(user.user_id)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                
                <div className="mt-4 text-center">
                    <button
                        onClick={handleSave}
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                        Új hírlevéllista mentése
                    </button>
                </div>

            </>
            }
            </div>
        </div>
    );
}
